import type {ReactElement} from 'react';
import React, {useEffect} from 'react';
import type {TabItems} from '@Components/tabs';
import {Tabs} from '@Components/tabs';
import {selectTab} from '@Components/tabs/tabs-reducer';
import styles from './contextual-menu-tabs-header.module.scss';
import {useAppDispatch} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';

interface ContextualMenuTabsHeaderProps {
  id: string;
  className?: string;
  tabData: TabHeaderItemStorage[];
  selectedTabId: string;

  onClick(key: string): void;
}

export interface TabHeaderItemStorage {
  id: string;
  text: string;
  className?: string;
}

export function ContextualMenuTabsHeader({className = '', ...props}: ContextualMenuTabsHeaderProps): ReactElement<any> | null {
  const dispatch = useAppDispatch();
  const activeItemId = useSingleActivePosterItemId();

  useEffect((): void => {
    dispatch(selectTab(props.id, props.selectedTabId));
  }, [activeItemId]);

  const getTabItems = (): TabItems => {
    const data = [];
    for (let index = 0; index < props.tabData.length; index += 1) {
      data.push({
        tabKey: props.tabData[index].id,
        text: props.tabData[index].text,
        className: `${props.tabData[index].className} spacing-m-r-10 spacing-p-t-5 spacing-p-b-4`,
      });
    }
    return data;
  };

  return (
    <Tabs
      onTabClick={(tabKey): void => {
        props.onClick(tabKey);
      }}
      id={props.id}
      className={`${className} ${styles.tabs} spacing-m-b-0`}
      tabItems={getTabItems()}
      selectedTab={props.selectedTabId}
    />
  );
}
